import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import { useState } from 'react';

export function useEditAccount(props) {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isEditingAccount, setIsEditingAccount] = useState();

    function handleAccount_edit(selectedAccounts) {
        if (func_validation.isArrayNotEmpty(selectedAccounts) &&
            func_validation.isArrayLengthEqual(selectedAccounts, 1)) {

            if (func_validation.isFunction(props.setSelectedBillingSetup)) 
                props.setSelectedBillingSetup(selectedAccounts);

            setIsFormVisible(true);
            setIsEditingAccount(true);
        }
        else if (func_validation.isArrayEmpty(selectedAccounts))
            Toaster({ type: "info", msg: "Please select a row" });
        else Toaster({ type: "info", msg: "Please select only 1 row" });
    }

    return {
        isFormVisible, setIsFormVisible,
        isEditingAccount, setIsEditingAccount,
        handleAccount_edit
    }
}